import type { ReactNode } from 'react'
import { useAuth } from '../auth/AuthContext'
import LoginScreen from './LoginScreen'

export default function AuthGate({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <p style={{ textAlign: 'center', marginTop: 80, color: 'var(--text-muted)' }}>Loading…</p>
  }
  if (!user) {
    return <LoginScreen />
  }
  return <>{children}</>
}
